import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

export const TextForReference: React.FC = () => {
    const {t} = useTwinTranslation()
    const parameters: TwinDictionary = {
        '{cat_ref}': t('categoryReference', 'Referencia de categoría'),
        '{counter}': t('categoryCounter', 'Contador de categoría'),
        '{parent_ref}': t('parentRef', 'Referencia del padre'),
        '{variants_ref}': t('variantsRef', 'Referencia del las variantes'),
    }
    const renderThis: JSX.Element[] = []
    for (const key in parameters) {
        renderThis.push(<div key={key}><span className='medium14'>{key}</span> - {parameters[key]}</div>)
    }
    return (
        <div className='col-span-3'>
            <span><TwinTrans transKey={'useNextParametersForGeneration'}>Utiliza los siguientes parámetros para la generación automática</TwinTrans>:</span>
            {renderThis}
        </div>
    )
}

export const TextForSubproducts: React.FC = () => {
    const {t} = useTwinTranslation()
    const parameters: TwinDictionary = {
        '{parent_name}': t('parentProductName', 'Nombre del producto padre'),
        '{variants_name}': t('variantsSubproductName', 'Nombre de las variables del subproducto'),
        '{variants_ref}': t('variantsSubproductCode', 'Código de las variables del subproducto'),
    }
    const renderThis: JSX.Element[] = []
    for (const key in parameters) {
        renderThis.push(<div key={key}><span className='medium14'>{key}</span> - {parameters[key]}</div>)
    }
    return (
        <div className='col-span-3'>
            <span><TwinTrans transKey={'useNextParametersForGeneration'}>Utiliza los siguientes parámetros para la generación automática</TwinTrans>:</span>
            {renderThis}
        </div>
    )
}
